import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./styled.js";
const CounterButtonDesktop = ({ children , onClick , disabled =false , classMod ='' , ...rest })=>/*#__PURE__*/ _jsx(S.CounterButtonWrapper, {
        "data-testid": "CounterButton",
        height: "28px",
        p: "8px",
        onClick: onClick,
        disabled: disabled,
        ...rest,
        className: classMod,
        children: children
    });
export default CounterButtonDesktop;

//# sourceMappingURL=index.js.map